import { render } from "./EditEventSocials.vue?vue&type=template&id=30d4808b"
import script from "./EditEventSocials.vue?vue&type=script&lang=js"
export * from "./EditEventSocials.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__